import { SETTINGS } from "APP_ROOT/constants";
import {
  BOOKMARKS,
  REPAIR_CART_ITEMS,
  SALES_CART_ITEMS,
  USER
} from "MODULES/users/constants";

export default {
  login: (user, settings) => {
    window.localStorage.setItem(USER, JSON.stringify(user));
    if (settings)
      window.localStorage.setItem(SETTINGS, JSON.stringify(settings));
  },
  setBookmarks: bookmarks => {
    window.localStorage.setItem(BOOKMARKS, JSON.stringify(bookmarks));
  },
  setSettings: settings => {
    window.localStorage.setItem(SETTINGS, JSON.stringify(settings));
  },
  setRepairCartItems: repairCartItems => {
    window.localStorage.setItem(
      REPAIR_CART_ITEMS,
      JSON.stringify(repairCartItems)
    );
  },
  setSalesCartItems: salesCartItems => {
    window.localStorage.setItem(
      SALES_CART_ITEMS,
      JSON.stringify(salesCartItems)
    );
  },
  logout: () => {
    [BOOKMARKS, USER, REPAIR_CART_ITEMS, SALES_CART_ITEMS].forEach(f =>
      window.localStorage.removeItem(f)
    );
  }
};



// WEBPACK FOOTER //
// ./app/session.js